import * as types from './constants';

export const initialState = {
  data: null,
  loading: false,
  cancelling: false,
  errors_api: {}
};

const actions = {
  [types.GET_NETWORK_ORDER_DETAIL_REQUEST]: state => ({
    ...state,
    loading: true
  }),

  [types.GET_NETWORK_ORDER_DETAIL_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),

  [types.GET_NETWORK_ORDER_DETAIL_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  }),

  [types.GET_NETWORK_ORDER_DETAIL_RESET]: state => ({
    ...state,
    data: null,
    errors_api: {}
  }),

  [types.CANCEL_NETWORK_ORDER_REQUEST]: state => ({
    ...state,
    cancelling: true
  }),

  [types.CANCEL_NETWORK_ORDER_DONE]: (state, { payload }) => ({
    ...state,
    cancelling: false,
    data: payload
  }),

  [types.CANCEL_NETWORK_ORDER_FAILED]: (state, { payload }) => ({
    ...state,
    cancelling: false,
    errors_api: payload
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
